import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'login_or_join_v3',
		path: ['/v3/login_or_join', '/v3/login_or_join/redirected', '/v3/login', '/v3/join', '/v3/login/join'],
		component: loadable(async () => import(/* webpackChunkName: "pages/loginOrSignupV3" */ './index'), {
			exportName: 'LoginOrSignupV3',
			fallback: Loading,
		}),
		frame: { footer: false, header: true },
		preventCookieWall: true,
		ssr: {
			enabled: true,
			seo: false,
		},
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support'],
		},
	},
];
